/**
 * @namespace jwsdwOCAPI
 */
'use strict';

(function (angular) {
    angular.module('jwsdw.ocapi', []);
}(angular));